inputs-textarea
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | { opts.label }
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      textarea(if="{!opts.disabled}" class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" onChange="{this.onChange}" rows="{opts.rows}") { opts.value }
      textarea(if="{ opts.disabled}" class="form-control { opts.klass }" name="{ opts.name }" placeholder="{ opts.placeholder }" type="text" onChange="{this.onChange}" rows="{opts.rows}" disabled="disabled") { opts.value }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.textarea');
